<ngx-awesome-uploader
    [adapter]="adapter"
    [totalMaxSize]="50"
    (fileAdded)="onFileAdded($event)"
    (uploadSuccess)="onUploadSuccess($event)"
    (uploadFail)="onUploadFail($event)"
>
</ngx-awesome-uploader>
